import { render, staticRenderFns } from "./PacsAnalyticsSettingsFrame.vue?vue&type=template&id=004caa43"
import script from "./PacsAnalyticsSettingsFrame.vue?vue&type=script&lang=js"
export * from "./PacsAnalyticsSettingsFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports